import React from "react";
import Select from "react-select";
import moment from "moment";
// import DownArrow from "@mui/icons-material/KeyboardArrowDownRounded";
// import { Menu, MenuItem } from "@mui/material";
import { useSelector } from "react-redux";
import { selectUser } from "../../features/auth/authSlice";

const FilterList = ({
  // open,
  // handleClick,
  // patientType,
  // anchorEl,
  // handleClose,
  // handlePatientType,
  patients,
  selectedPatients,
  handleSelectedPatients,
  fetchPatients,
  patientsLoading,
  providers,
  selectedProviders,
  handleSelectedProviders,
  fetchProviders,
  providersLoading,
  zones,
  selectedZones,
  handleSelectedZones,
  fetchZones,
  zonesLoading,
  handleApplyFilters,
}) => {
  const user = useSelector(selectUser);
  return (
    <div className="flex flex-col w-full gap-8 p-6 border-b bg-backgroundblue border-primarygrayborder h-fit">
      <div className="flex flex-col items-end gap-1">
        {/* <div className="flex flex-row items-center justify-between">
          <button
            onClick={handleClick}
            className="flex-row gap-1 d-flex align-items-center justify-content-center"
          >
            <span className="text-sm font-bold color-1">{patientType}</span>
            <DownArrow className="color-1" />
          </button>
          <Menu
            open={open}
            anchorEl={anchorEl}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
            onClose={handleClose}
          >
            {[
              "All",
              "Overdue",
              "New",
              "Recently discharged",
              "Cross Cover",
            ].map((data, ind) => (
              <MenuItem
                key={ind}
                style={{
                  fontSize: 14,
                }}
                onClick={() => {
                  handlePatientType(data);
                  handleClose();
                }}
              >
                {data}
              </MenuItem>
            ))}
          </Menu>
        </div> */}
      {user?.permissions?.includes('patient_panel_visualizer.search_patient') && <Select
          placeholder="Search by Patient..."
          isSearchable
          isClearable
          className="w-full overflow-visible h-9 z-[1000]"
          isMulti
          value={selectedPatients}
          onChange={handleSelectedPatients}
          options={patients}
          noOptionsMessage={() => "Search By Name..."}
          isLoading={patientsLoading}
          onMenuOpen={() => fetchPatients("", true)}
          onInputChange={(inputValue, { action }) => {
            if (action === "input-change") {
              fetchPatients(inputValue, true);
            }
          }}
          formatOptionLabel={(option) => (
            <div className="flex flex-col">
              <span className="font-medium">{option.label}</span>
              <span className="text-xs text-gray-500">
                <span className="font-semibold">Date of Birth: </span>
                {option.dob !== "NA"
                  ? `${moment(option.dob).format("MM/DD/YYYY")}`
                  : ""}
              </span>
            </div>
          )}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
            option: (base) => ({
              ...base,
              padding: "8px 12px",
            }),
            multiValue: (base) => ({
              ...base,
              backgroundColor: "#EFF6FF",
              borderRadius: "4px",
            }),
            multiValueLabel: (base) => ({
              ...base,
              color: "#1E40AF",
              fontWeight: 500,
            }),
          }}
        />}
      </div>
     {/* {user?.permissions?.includes('patient_panel_visualizer.search_zone') && <Select
        placeholder="Search by Zone..."
        isSearchable
        isClearable
        className="w-full overflow-visible h-9 z-[1000]"
        isMulti
        value={selectedZones}
        onChange={handleSelectedZones}
        options={zones}
        noOptionsMessage={() => "Search By Name..."}
        isLoading={zonesLoading}
        onMenuOpen={() => fetchZones("", true)}
        onInputChange={(inputValue, { action }) => {
          if (action === "input-change") {
            fetchZones(inputValue);
          }
        }}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
      />} */}
      {user?.permissions?.includes('patient_panel_visualizer.search_provider') && <Select
        placeholder="Search by Provider..."
        isSearchable
        isClearable
        className="w-full overflow-visible h-9 z-[1000]"
        isMulti
        value={selectedProviders}
        onChange={handleSelectedProviders}
        options={providers}
        noOptionsMessage={() => "Search By Name..."}
        isLoading={providersLoading}
        onMenuOpen={() => fetchProviders("", true)}
        onInputChange={(inputValue, { action }) => {
          if (action === "input-change") {
            fetchProviders(inputValue);
          }
        }}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
      />}
      {/* <Select
        placeholder="Search by Appointment Type..."
        isSearchable
        isClearable
        className="w-full overflow-visible h-9 z-[1000]"
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
      /> */}
      <button
        onClick={handleApplyFilters}
        disabled={providersLoading}
        className="flex items-center justify-center text-sm font-bold text-white rounded-sm bg-primaryblue h-9 disabled:opacity-50"
      >
        Apply Filters
      </button>
    </div>
  );
};

export default FilterList;
